import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Your recruitment is completed!")
], -1)
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6" }
const _hoisted_7 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, " You have successfully updated your recruitment. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
          ]),
          _hoisted_8
        ])
      ])
    ])
  ]))
}